import { useState, forwardRef, useImperativeHandle, useRef, useCallback } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SourceIcon from '@mui/icons-material/Source';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Box, Grid, IconButton, InputAdornment, OutlinedInput, Stack, Tooltip, Typography} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useEffect } from 'react';
import {RemoveRedEye} from "@mui/icons-material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";

const uploadMultipleFilePopup = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [documentFile, setDocumentFile] = useState([]);
    const [documentName, setDocumentName] = useState([]);
    const [openViewDocument,setOpenViewDocument]=useState(false)
    const [documentList,setDocumentList]=useState([])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
        setDocumentName([...documentName, file.name]);
        setDocumentFile([...documentFile, file]);
    }


    useEffect(() => {
        if (props?.data?.uploadFile) {
            setDocumentName(props.data.uploadFile);
            if(props.data.file){
            setDocumentFile(props.data.file);
            }
        }
    }, [props?.data]);

    const removeDocument = (name)=>{
        const result = documentName.filter((item)=> item !== name)
        setDocumentName(result);
        const filterFile=documentFile.filter((item)=>item.name !== name)
        setDocumentFile(filterFile)
        setDocumentList([])
    }


    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowData = props?.node;
                rowData.setDataValue("file", documentFile);
                return documentName;
            }
        };
    });


    return (
        <div>
            <IconButton onClick={handleClickOpen}><SourceIcon color="warning" /></IconButton>
            <Dialog fullWidth maxWidth={'sm'}
                open={open}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Upload documents"}</DialogTitle>

                <DialogContent>
                    <Grid
                        sx={{

                            height: 400,

                        }}>
                        <Stack className='w-full mb-16'>
                            <Box className='flex justify-center items-center'
                                sx={{

                                    height: 180,
                                    border: '1px dotted grey',
                                }}
                            >
                                <CloudUploadIcon fontSize={'large'} /><Typography className='ml-12' >Upload your image</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    color="warning"
                                    className='ml-12'
                                >
                                    <input hidden type="file" multiple
                                        onChange={(e) => handleDocumentChange(e)}
                                    />
                                    <Typography color="black">Browse</Typography>
                                </Button>
                            </Box>
                        </Stack>

                        <Stack className='w-full mb-16'>
                            {documentName.map((name,index) => {
                                return (

                                <Box
                                    className='flex justify-between'
                                >
                                    <Grid className='flex'>
                                        <div>
                                            <FileCopyIcon fontSize={'large'} color="warning" className=' mt-20' />
                                        </div>
                                        <div>
                                            <Typography fontSize={'large'} className='ml-12 mt-20' >{name}</Typography>

                                        </div>
                                    </Grid>
                                    <Grid>
                                        <Tooltip title={"View file"}>
                                            <IconButton className='mt-20 cursor-pointer' onClick={async () => {
                                                var reader = new FileReader();
                                                reader.onload = async function (upload) {
                                                    await setDocumentList([upload.target.result]);
                                                };
                                                await reader.readAsDataURL(documentFile[index]);
                                                await setOpenViewDocument(true)
                                            }}><RemoveRedEye className='' /></IconButton>
                                        </Tooltip>
                                    <IconButton className='mt-20 cursor-pointer' onClick={()=>removeDocument(name,index)}><ClearIcon className='w-32 h-32'/></IconButton>
                                        {/* <FuseSvgIcon  onClick={() => removeDocument(name,documentName)}>heroicons-outline:x</FuseSvgIcon> */}
                                    </Grid>
                                </Box>
                            )})}
                        </Stack>

                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button onClick={handleClose}>Uplaod</Button> */}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                onClose={()=>setOpenViewDocument(false)}
                open={openViewDocument}
            >
                <DialogTitle>
                    <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button onClick={()=>setOpenViewDocument(false)}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <img src={documentList?.[0]} alt={documentName} />
                </DialogContent>
            </Dialog>
        </div>
    )
})

export default uploadMultipleFilePopup